import React, { useState } from 'react';
import axios from 'axios';

const DebugTransform = () => {
  const [input, setInput] = useState('');
  const [output, setOutput] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [apiResponse, setApiResponse] = useState(null);
  
  const handleTransform = async () => {
    if (!input.trim()) return;
    
    setIsLoading(true);
    setOutput('');
    setApiResponse(null);
    
    try {
      // Direct call to claude-direct API endpoint
      console.log("Sending direct request to claude-direct");
      const response = await axios.post('/api/v1/claude-direct', {
        prompt: `Transform: ${input}`,
        system: "You are Emit, a Fhoism philosopher"
      }, {
        // Bypass any interceptors
        headers: {
          'X-Debug-Mode': 'true',
          'Content-Type': 'application/json'
        }
      });
      
      console.log("DEBUG RESPONSE:", response.data);
      setApiResponse(response.data);
      
      if (response.data && response.data.completion) {
        // Clean the completion text by removing system tags
        let cleanedText = response.data.completion;
        
        // Remove system tags
        cleanedText = cleanedText.replace(/<userStyle>[\s\S]*?<\/userStyle>/g, '');
        cleanedText = cleanedText.replace(/<search_reminders>[\s\S]*?<\/search_reminders>/g, '');
        cleanedText = cleanedText.replace(/<automated_reminder_from_anthropic>[\s\S]*?<\/automated_reminder_from_anthropic>/g, '');
        cleanedText = cleanedText.replace(/<citation_instructions>[\s\S]*?<\/citation_instructions>/g, '');
        
        setOutput(cleanedText);
      } else {
        setOutput("Error: No completion in response");
      }
    } catch (error) {
      console.error("Transform error:", error);
      setOutput(`Error: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };
  
  return (
    <div style={{ maxWidth: '800px', margin: '40px auto', padding: '20px', fontFamily: 'Arial' }}>
      <h1>Debug Transform</h1>
      <p><strong>Bypass all middleware and fallback systems</strong></p>
      
      <div style={{ marginBottom: '20px' }}>
        <textarea
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Enter text to transform..."
          style={{ 
            width: '100%', 
            height: '100px', 
            padding: '10px',
            marginBottom: '10px' 
          }}
        />
        <button
          onClick={handleTransform}
          disabled={isLoading || !input.trim()}
          style={{
            padding: '10px 20px',
            backgroundColor: '#2196F3',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          {isLoading ? 'Processing...' : 'Transform (Debug)'}
        </button>
      </div>
      
      {apiResponse && (
        <div style={{ 
          marginBottom: '20px',
          padding: '10px',
          border: '1px solid #ccc',
          backgroundColor: '#f0f0f0',
          fontSize: '12px',
          maxHeight: '200px',
          overflow: 'auto'
        }}>
          <h3>Raw API Response:</h3>
          <pre>{JSON.stringify(apiResponse, null, 2)}</pre>
        </div>
      )}
      
      {output && (
        <div style={{
          padding: '20px',
          backgroundColor: '#e3f2fd',
          border: '2px solid #2196F3',
          borderRadius: '4px'
        }}>
          <h2>Transformation Output:</h2>
          <div style={{ whiteSpace: 'pre-wrap' }}>
            {output}
          </div>
        </div>
      )}
    </div>
  );
};

export default DebugTransform;
